module.exports = __webpack_public_path__ + "static/media/Von hier oben aus.5b9267a9.ogg";